import {Box, Container, Stack, styled} from '@mui/material';
import {HeaderText} from 'components';
import PartnersImg from 'assets/images/svg/partners.svg';
import SinSo from 'assets/images/sinso-logo.png';
import {useTranslation} from 'react-i18next';
import {useMatchesSize} from 'common/useMatchesSize';

const Partners = () => {
  const {t} = useTranslation();
  const {md} = useMatchesSize();

  return (
    <Box py={9}>
      <Container>
        <Stack spacing={7.5} alignItems="center">
          <HeaderText isSmall={false} textAlign="center">
            {t('homepage.partner')}
          </HeaderText>
          <Stack direction={md ? 'column' : 'row'} spacing={5}>
            <StyledImg
              src={PartnersImg}
              alt=""
              onClick={() => window.open('https://www.alpacafinance.org/')}
            />
            <StyledImg
              src={SinSo}
              alt=""
              onClick={() => window.open('https://www.sinso.io/')}
            />
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

const StyledImg = styled('img')(({theme}) => ({
  width: theme.spacing(40),
  [theme.breakpoints.down('sm')]: {
    width: theme.spacing(30),
  },
}));

export {Partners};
